import React from 'react';
import clsx from 'clsx';
import TippingArticleCard from './Card';
import styles from './index.module.scss';

interface Article {
  id: string;
  name: string;
  description: string;
  file?: { location: string };
  tags: { id: string; name: string }[];
  createdAt: string;
}

interface TippingArticleListProps {
  articles: Article[];
  prependItem?: React.ReactNode;
  header?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

function TippingArticleList({
  articles,
  prependItem,
  header,
  style,
  className,
}: TippingArticleListProps) {
  return (
    <div className={clsx(styles.items, className)} style={style}>
      {header && <div className={styles.header}>{header}</div>}

      {prependItem}

      {articles.length === 0 ? (
        <div className={styles.noresults}>
          Nothing has been found for this search.
        </div>
      ) : (
        articles.map((item) => <TippingArticleCard key={item.id} item={item} />)
      )}
    </div>
  );
}

export default TippingArticleList;
